import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import type { ToastProps } from '~/components/granular/toast/toast.types';

export interface ToastState extends ToastProps {
  key: string;
}

export const toastsAtom = atom<ToastState[]>([]);

/**
 * @description Add a toast to the global state
 * @returns {addToast} - The function to add a toast to the global state
 * @returns {removeToast} - The function to remove a toast from the global state
 */
export function useToast() {
  const setToasts = useSetAtom(toastsAtom);

  const addToast = useCallback(
    (toast: ToastProps) => {
      setToasts((prev) => [...prev, { ...toast, key: crypto.randomUUID() }]);
    },
    [setToasts],
  );

  const removeToast = useCallback(
    (id: string) => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    },
    [setToasts],
  );

  return { addToast, removeToast };
}

/**
 * @description Return all toasts in the global state
 * @returns {ToastState[]} - The toasts in the global state
 */
export function useToasts() {
  return useAtomValue(toastsAtom);
}
